import { render } from "./cell_attributetable.vue?vue&type=template&id=3963b614"
import script from "./cell_attributetable.vue?vue&type=script&lang=ts"
export * from "./cell_attributetable.vue?vue&type=script&lang=ts"
script.render = render

export default script